module.exports = __webpack_public_path__ + "img/awave.7a8c5924.png";